import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CREATE_PUBLISHER_BY_EMPLOYEE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation createPublisherByEmployee($input: CreatePublisherByEmployeeInput!) {
    createPublisherByEmployee(input: $input) {
      user {
        id
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
